import { render } from "./ChatMenu.vue?vue&type=template&id=2061cb5c"
import script from "./ChatMenu.vue?vue&type=script&lang=js"
export * from "./ChatMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__